(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('appraisal-firm-insurance', {
            parent: 'entity',
            url: '/appraisal-firm-insurance?page&sort&search&missingOnly',
            data: {
                authorities: [/^ROLE_(ADMIN|CUSTOMER_CARE_REPRESENTATIVE|VC.*)$/],
                pageTitle: 'valueconnectApp.appraisalFirm.insuranceStatus.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/appraisal-firm-insurance/appraisal-firm-insurance.html',
                    controller: 'AppraisalFirmInsuranceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: { value: '1', squash: true },
                sort: { value: 'name,asc', squash: true },
                search: { value: '', squash: true },
                missingOnly: { value: null, squash: true }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        missingOnly: $stateParams.missingOnly === 'true'
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appraisalFirm');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
